import React from 'react'
import PropTypes from 'prop-types'

// components
import { Text, Avatar, Button, Unless, If, CloseButton } from '../../../../components'
import LenderStats from '../../../../components/LenderStats'

// Utils
import { useBranding } from '../../../../hooks/branding'
import { usePrequalRequestAsync } from '../../../../hooks/requests'

// Assets
import styles from './CospoPrequalPrompt.module.scss'

const CospoPrequalPrompt = ({ onClose }) => {
  const {
    customerPhotoUri,
    customerFirstName,
    customerLastName,
    customerStatement,
    sponsorFirstName,
    sponsorLastName,
    sponsorPhotoUri,
  } = useBranding()

  const {
    execute: sendPrequalRequest,
    isLoading,
    isSuccess: showSuccessInfo,
    promptRetry,
  } = usePrequalRequestAsync()

  return (
    <div className={styles.wrapper}>
      <div className={styles.root}>
        <div className={styles.contents}>
          <CloseButton className={styles.close} onClick={onClose} />
          <Unless condition={showSuccessInfo}>
            <div className={styles.avatarWrap}>
              <Avatar className={styles.avatar} src={customerPhotoUri} />
              <Avatar className={styles.avatar} src={sponsorPhotoUri} />
            </div>
            <Text align='center' color='white' size='xl'>
              Speed Up Pre-Qualification
            </Text>
            <Text align='center' className={styles.subheader}>
              {`${customerFirstName} trusts the expert advice of lender ${sponsorFirstName} ${sponsorLastName}`}
            </Text>
            {customerStatement && (
              <div>
                <Text
                  align='center'
                  color='heather'
                  size='s'
                  transform='uppercase'
                  weight='bold'
                >{`About ${customerFirstName} ${customerLastName}`}</Text>
                <Text
                  align='center'
                  className={styles.statement}
                >{`"${customerStatement}"`}</Text>
              </div>
            )}
            <LenderStats center />
            <Unless condition={promptRetry}>
              <Button
                primary
                fullWidth
                loading={isLoading}
                className={styles.getIntroButton}
                onClick={sendPrequalRequest}
              >
                Get Intro
              </Button>
              <Button
                regular
                fullWidth
                className={styles.button}
                onClick={() => onClose()}
              >
                Maybe Later
              </Button>
            </Unless>
            <If condition={promptRetry}>
              <Text align='center' color='white'>
                Something went wrong.
              </Text>
              <Button
                minimal
                loading={isLoading}
                className={styles.retry}
                onClick={sendPrequalRequest}
              >
                Retry getting an intro?
              </Button>
            </If>
          </Unless>
          <If condition={showSuccessInfo}>
            <div className={styles.avatarWrap}>
              <Avatar className={styles.avatar} src={sponsorPhotoUri} />
            </div>
            <Text align='center' color='white' size='xl'>
              Talk to You Soon
            </Text>
            <Text align='center' className={styles.lookOut}>
              {`Keep a look out for a phone call or email from ${sponsorFirstName} ${sponsorLastName} in the next few days.`}
            </Text>
            <Button
              primary
              fullWidth
              className={styles.closeButton}
              onClick={() => onClose()}
            >
              Sounds Good
            </Button>
          </If>
        </div>
      </div>
    </div>
  )
}

CospoPrequalPrompt.propTypes = {
  onClose: PropTypes.func,
}

export default CospoPrequalPrompt
